<template>
  <div style="margin-bottom:15px;">
    <a-button size="normal"
              @click="refreshData">刷新</a-button>
    <a-button v-p="'/authorizations/organizations/:organizationId/users:POST'"
              size="normal"
              @click="addAssociationRole">添加关联用户</a-button>
    <a-popconfirm title="是否确定删除选中的关联用户"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="deleteConfirm">
      <a-button v-p="'/authorizations/organizations/:organizationId/users/:id?:DELETE'"
                :disabled="selectedRow.length > 0 ? false : true"
                size="normal">删除关联</a-button>
    </a-popconfirm>
  </div>
  <a-table :data-source="dataSource"
           row-key="id"
           :columns="columns"
           :custom-row="customRowFn"
           :loading="loading"
           :row-selection="{ selectedRowKeys: selectedRow, type: 'checkbox', onChange: onSelectChange }">
    <template #bodyCell="{ column, text, record }">
      <template v-if="column.dataIndex === 'username'">
        <div class="editable-cell">
          <div class="editable-cell-text-wrapper">
            {{ text }}
          </div>
        </div>
      </template>
      <template v-else-if="column.dataIndex === 'operation'">
        <a @click="deleteAssociationRoleRow(record)">删除关联</a>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="deleteAssociationRoleVisible"
           title="删除"
           :confirm-loading="confirmLoading"
           @ok="deleteRoleConfirm">
    <p style="font-size:16px">是否删除关联用户：<span style="color:red">{{ deleteAssociationRoleForm.name }}</span></p>
  </a-modal>
  <a-modal v-model:visible="addAssociationRoleVisible"
           title="添加关联用户"
           width="140vh"
           @ok="addAssociationRoleConfirm">
    <!-- <a-table :dataSource="dataSource" :columns="columns"></a-table> -->
    <splitpanes class="default-theme splitPanesMain"
                :push-other-panes="false">
      <pane size='70'
            min-size="0"
            max-size="55">
        <a-card title="列表">
          <a-table :scroll="{ y: 270 }"
                   row-key="id"
                   :data-source="adddataSource"
                   :columns="addColumns"
                   :loading="modalTableLoading"
                   :custom-row="addCustomRowFn"
                   :row-selection="{ selectedRowKeys: addselectedRow, onChange: addOnSelectChange, type: 'checkbox' }">
          </a-table>
        </a-card>
      </pane>
      <pane size='30'
            min-size="40"
            max-size="55"
            style="overflow:auto">
        <a-card :title='"已选" + addSelectedArray.length + "条"'>
          <template #extra>
            <a v-if="addSelectedArray.length"
               herf="#"
               @click="deleteAllSelected">清空</a>
          </template>
          <div>
            <a-tag v-for="item in addSelectedArray"
                   :key="item.id"
                   closable
                   @close="deleteRow(item)">{{
                     item.name
                   }}
            </a-tag>
          </div>
        </a-card>
      </pane>
    </splitpanes>
  </a-modal>
</template>

<script setup lang="ts">
import { CORE_AXIOS, type Http } from '@/core'
import type { RbacRoleState } from '@/plugins'
import { message } from 'ant-design-vue'
import { remove } from 'lodash'
import { Pane, Splitpanes } from 'splitpanes'
import { container } from 'tsyringe'
import { reactive, ref, watch } from 'vue'
import { useRbacStore } from '../../DefaultRbacPagePlugin'

const rbac = useRbacStore()
const organizationsid = ref<string>()
const axios = container.resolve<Http>(CORE_AXIOS)
// 表层操作逻辑
//  定义基础数据
const loading = ref<boolean>(false)
const confirmLoading = ref<boolean>(false)
const modalTableLoading = ref<boolean>(false)
const dataSource: Array<RbacRoleState> = reactive([])

// 监听模块
// 1.监听是否已选择“组织管理”中的数据
watch(
  () => rbac.$state.models.organization, (state) => {
    organizationsid.value = state[0] as string
    refreshData()
  }, {
  deep: true
}
)
/** -------监听模块 End ------------- */

// 业务模块
// 【业务模块】-[按钮]-[刷新] refresh(刷新表格数据)
const refreshData = () => {
  loading.value = true
  selectedRow.length = 0
  axios.get('/v1/api/authorizations/organizations/' + organizationsid.value + '/users?limit=20&offset=0').then(result => {
    const { users } = result as { users: RbacRoleState[], total: number }
    dataSource.length = 0
    dataSource.push(...users)
    loading.value = false
  })
}

//  【业务模块】-[按钮]-[添加关联用户]  addAssociationRole(打开关联用户Modal)
const addAssociationRole = () => {
  modalTableLoading.value = true
  addselectedRow.length = 0
  addSelectedArray.length = 0
  addAssociationRoleVisible.value = true
  axios.get('/v1/api/authorizations/organizations/' + organizationsid.value + '/not_in/users?limit=20&offset=0').then(result => {
    const { users } = result as { users: RbacRoleState[], total: number }
    adddataSource.length = 0
    adddataSource.push(...users)
    modalTableLoading.value = false
  })
}

//  【业务模块】-[按钮]-[删除关联]-Modal-confirm (删除关联 对话确认框确认方法)
const deleteConfirm = () => {
  axios.delete('/v1/api/authorizations/organizations/' + organizationsid.value + '/users?ids=' + selectedRow.join(',')).then(() => {
    message.success('删除成功')
    refreshData()
  })
}

// 【表格模块】
// 【表格模块】-[表格行]-rowClick(选中表格单挑数据)
const customRowFn = (record: RbacRoleState) => {
  return {
    onclick: () => {
      // 判断是否已勾选中此条数据
      if (!selectedRow.find(item => item == record.id)) {
        selectedRow.push(record.id)
      } else {
        selectedRow.forEach((item, index) => {
          if (item == record.id) {
            selectedRow.splice(index, 1)
          }
        })
      }
    }
  }
}

// 【表格模块】-[多选框]-checkboxClick(选中多选框)
const onSelectChange = (keys: Array<string>) => {
  remove(selectedRow)
  selectedRow.push(...keys)
}

// 【表格模块】-[操作列]-[删除关联]-Modal (打开删除关联Modal)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const deleteAssociationRoleRow = (rowData: any) => {
  deleteAssociationRoleForm.value = rowData
  deleteAssociationRoleVisible.value = true
}

// 【表格模块】-[操作列]-[删除关联]-Modal-Confirm(删除关联Modal 确认方法)
const deleteRoleConfirm = () => {
  confirmLoading.value = true
  axios.delete('/v1/api/authorizations/organizations/' + organizationsid.value + '/users?ids=' + deleteAssociationRoleForm.value.id).then(() => {
    deleteAssociationRoleVisible.value = false
    confirmLoading.value = false
    message.success('删除成功')
    refreshData()
  })
}

// 添加关联用户模块(modal)
//  定义基础数据
const selectedRow: Array<string> = reactive([])
const addSelectedArray: Array<RbacRoleState> = reactive([])
const addselectedRow: Array<string> = reactive([])
const deleteAssociationRoleVisible = ref<boolean>(false)
const addAssociationRoleVisible = ref<boolean>(false)
const adddataSource: Array<RbacRoleState> = reactive([])
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const deleteAssociationRoleForm = ref<any>()
// 【模块管理】
// 【模块管理】-Modal-Confirm（确认）
const addAssociationRoleConfirm = () => {
  const ids: string[] = []
  addSelectedArray.forEach(item => {
    ids.push(item.id)
  })
  axios.post('/v1/api/authorizations/organizations/' + organizationsid.value + '/users', { ids }).then(() => {
    addAssociationRoleVisible.value = false
    message.success('添加成功！')
    refreshData()
  })
}
// 【模块管理】-[表格]-rowClick(选中单条数据)
const addCustomRowFn = (record: RbacRoleState) => {
  return {
    onclick: () => {
      // 判断是否已勾选中此条数据
      if (!addselectedRow.find(item => item == record.id)) {
        addselectedRow.push(record.id)
        addSelectedArray.push(record)
      } else {
        addselectedRow.forEach((item, index) => {
          if (item == record.id) {
            addselectedRow.splice(index, 1)
            addSelectedArray.splice(index, 1)
          }
        })
      }
    }
  }
}
//  【模块管理】-[表格]-checkboxClick(选中多选框)
const addOnSelectChange = (keys: Array<string>) => {
  remove(addselectedRow)
  addselectedRow.push(...keys)
}
/** -------表格操作 End ------------- */


//  【模块管理】-[右侧操作模块]-deleteSingleData(删除单条已选择的数据)
const deleteRow = (item: RbacRoleState) => {
  remove(addSelectedArray, (el) => el.id == item.id)
  remove(addselectedRow, (el) => el == item.id)
}

//  【模块管理】-[右侧操作模块]-deleteAllData(删除所有已选择的数据)
const deleteAllSelected = () => {
  remove(addSelectedArray)
  remove(addselectedRow)
}

//* * -------模块管理 End -------------*/

const columns = ref([
  {
    title: '登录名',
    dataIndex: 'fullname',
    key: 'fullname'
  }, {
    title: "用户名",
    dataIndex: 'username',
    key: 'username'
  }, {
    title: "邮箱",
    dataIndex: 'email',
    key: 'email'
  }, {
    title: "关联时间",
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 130
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

const addColumns = ref([
  {
    title: '登录名',
    dataIndex: 'fullname',
    key: 'fullname'
  }, {
    title: "用户名",
    dataIndex: 'username',
    key: 'username'
  }, {
    title: "关联时间",
    dataIndex: 'createdAt',
    key: 'createdAt'
  }
])
</script>

<style lang="less" scoped>
.splitPanesMain {
  height: 60vh;
}

:deep(.splitpanes__splitter) {
  background-color: #95808017 !important;
}

:deep(.splitpanes__pane) {
  background-color: #f5f5f529 !important;
}

:deep(.ant-tag) {
  width: 100%;
}

:deep(.ant-tag:not(:first-child)) {
  margin-top: 20px;
}

:deep(.ant-table) {
  table {
    table-layout: fixed !important;
  }
}

:deep(.ant-table-tbody) {
  tr>td {
    word-wrap: break-word;
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
</style>
